
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {ENTITY} from '../constant';
import {httpserviceWithMultipart} from "../services/HttpServices";
let apiEndPoint = constants.ADMIN_URL;

export const doEmotionCreate = data => {
    return httpserviceWithMultipart('post', data, `${apiEndPoint}${constants.API.EMOTION}`)
        .then( (response) => {
            console.log(response)

            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });

};

export const doEmotionDelete = Id => {
    const endPointUri = constants.API.EMOTION_BY_ID.replace(ENTITY.EMOTION_ID, Id);
    return httpservice()
        .delete(endPointUri)
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};

export const doEmotionUpdate = (Id, data) => {
    const endPointUri = constants.API.EMOTION_BY_ID.replace(ENTITY.EMOTION_ID, Id);
    
    return httpserviceWithMultipart('put', data, `${apiEndPoint}${endPointUri}` )
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};
